<mat-dialog-content>
  <sk-license-details
    [orderId]="orderId"
    [o365Id]="o365Id">
  </sk-license-details>
</mat-dialog-content>
